// Libraries
import React from 'react'
import ReactDOM from 'react-dom/client'

// Styles
import './index.css'
import { mainTheme } from './theme/main'

// Components
import App from './App'

// Providers
import { ThemeProvider } from 'styled-components'
import { ChakraProvider } from '@chakra-ui/react'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider theme={mainTheme}>
    <ChakraProvider resetCSS={false}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ChakraProvider>
  </ThemeProvider>
);
